import React, {FC} from "react"

import {H1} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

import {IntroText} from "../../IntroText"
import Image from "../../styled/Image"
import RewardBadgeImage from "../../../images/wallet_green_badge.svg"

const AdminRewardIntro: FC = () => (
  <Flex direction="column" alignItems="flex-start" marginBottom={2}>
    <Flex direction="column">
      <Flex alignItems="center">
        <Image src={RewardBadgeImage} alt="Reward Wallet Badge" />
        <H1>
          <FormattedMessage id="wallet.reward.intro.header" />
        </H1>
      </Flex>
      <IntroText message="wallet.reward.admin.intro.text" />
    </Flex>
  </Flex>
)

export default AdminRewardIntro
